import { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';

import { RootLayout } from '@/components/layout';
import { ROUTES } from '@/constants';

/**
 * The site is a single page, so only the legal pages and the catch-all are
 * split out. They are still lazily loaded — most visitors never open them.
 */
const HomePage = lazy(() => import('@/pages/HomePage').then((m) => ({ default: m.HomePage })));
const LegalPage = lazy(() => import('@/pages/LegalPage').then((m) => ({ default: m.LegalPage })));
const NotFoundPage = lazy(() =>
  import('@/pages/NotFoundPage').then((m) => ({ default: m.NotFoundPage })),
);

export function AppRouter() {
  return (
    <Routes>
      <Route element={<RootLayout />}>
        <Route path={ROUTES.home} element={<HomePage />} />
        <Route path={ROUTES.privacy} element={<LegalPage document="privacy" />} />
        <Route path={ROUTES.terms} element={<LegalPage document="terms" />} />
        <Route path={ROUTES.notFound} element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
